const financialInfo = {
    emplStatus: '',
    sourceOfIncome: '',
    sourceOfWealth: '',
    annualIncome: '',
    assets: '',
    netWorth: '',
    schoolName: '',
    occupation: '',
    companyName: '',
    businessState: '',
    businessAddress: '',
    city: '',
    zipCode: '',
    countryName: '',
    businessPhone: '',
    soldBusinessName: '',
    soldAmount: '',
    soldBusinessDate: ''
};

const SET_FINANCIAL_INFO = 'SET_FINANCIAL_INFO';

export const setFinancialInfo = (financialInfo) => ({
    type: SET_FINANCIAL_INFO,
    payload: financialInfo,
});

const financial_store = (state = financialInfo, action) => {
    switch (action.type) {
        case SET_FINANCIAL_INFO:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default financial_store;
